module.exports = __webpack_public_path__ + "static/media/topBg.ac788e49.jpg";